export default __webpack_public_path__ + "static/media/laserPointer.64ea492c.svg";